"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Item = _interopRequireDefault(require("./Item"));

var _Placeholder = _interopRequireDefault(require("./Placeholder"));

var _uxcore = require("@ux/uxcore2");

var _services = _interopRequireDefault(require("../utils/services"));

var _constants = require("../utils/constants");

var _Expander = _interopRequireDefault(require("./Expander"));

var _helpers = require("../utils/helpers");

var _namespaceComponent = require("@ux/namespace-component");

var _reactIntl = require("react-intl");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var CartContent =
/*#__PURE__*/
function (_NamespaceConsumer) {
  _inherits(CartContent, _NamespaceConsumer);

  function CartContent(props) {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, CartContent);

    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(CartContent)).call.apply(_getPrototypeOf2, [this, props].concat(args)));
    _this.element = _react["default"].createRef();
    _this.state = {
      editing: false,
      placeholders: 0,
      items: props.basket ? props.basket.items : [],
      hasOverflow: false,
      offsetTop: null,
      height: null
    };
    _this.handleOverflow = _this.handleOverflow.bind(_assertThisInitialized(_this));
    _this.handleDelete = _this.handleDelete.bind(_assertThisInitialized(_this));
    _this.handleDurationChange = _this.handleDurationChange.bind(_assertThisInitialized(_this));
    _this.handleAddEvent = _this.handleAddEvent.bind(_assertThisInitialized(_this));
    _this.handleRemoveEvent = _this.handleRemoveEvent.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(CartContent, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      document.addEventListener(_constants.Events.ADD_ITEM, this.handleAddEvent);
      document.addEventListener(_constants.Events.REMOVE_ITEM, this.handleRemoveEvent);
      this.props.onChange && _services["default"].queue.addListener('empty', this.props.onChange);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearTimeout(this.debounceTimeout);
      document.removeEventListener(_constants.Events.ADD_ITEM, this.handleAddEvent);
      document.removeEventListener(_constants.Events.REMOVE_ITEM, this.handleRemoveEvent);
      this.props.onChange && _services["default"].queue.removeListener('empty', this.props.onChange);
    }
  }, {
    key: "handleAddEvent",
    value: function handleAddEvent() {
      this.setState({
        placeholders: this.state.placeholders + 1
      });
      this.props.onChange && this.props.onChange();
    }
  }, {
    key: "handleRemoveEvent",
    value: function handleRemoveEvent() {
      this.props.onChange && this.props.onChange();
    }
  }, {
    key: "handleOverflow",
    value: function handleOverflow(hasOverflow) {
      if (this.state.hasOverflow !== hasOverflow) {
        this.setState({
          hasOverflow: hasOverflow
        });
      }
    }
  }, {
    key: "handleDelete",
    value: function handleDelete(item) {
      var _this2 = this;

      var items = this.state.items.filter(function (i) {
        return i.itemId !== item.itemId;
      });
      setImmediate(function () {
        return _this2.setState({
          items: items,
          editing: true
        });
      });

      _services["default"].basket["delete"](item).then(function () {
        return document.dispatchEvent(new CustomEvent(_constants.Events.REMOVE_ITEM, {
          detail: item
        }));
      });
    }
  }, {
    key: "handleDurationChange",
    value: function handleDurationChange(item, newDuration) {
      var _item$periodOptions$f = item.periodOptions.find(function (option) {
        return option.period === newDuration;
      }),
          pfid = _item$periodOptions$f.pfid;

      if (item.pfid !== pfid) {
        this.setState({
          editing: true
        });

        _services["default"].basket.patch({
          items: [{
            itemId: item.itemId,
            pfid: pfid
          }]
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$state = this.state,
          items = _this$state.items,
          editing = _this$state.editing,
          placeholders = _this$state.placeholders,
          hasOverflow = _this$state.hasOverflow;
      var _this$props = this.props,
          basket = _this$props.basket,
          loading = _this$props.loading,
          market = _this$props.market,
          currency = _this$props.currency,
          language = _this$props.language;
      var isBasketEmpty = !basket || !basket.items || !basket.items.length;
      var hasGroups = basket && basket.groups && basket.groups.length;
      var reversedItems = items && items.slice(0).reverse();

      if (loading && isBasketEmpty && !placeholders) {
        return _react["default"].createElement("div", {
          className: this.namespace('hc-loading')
        }, _react["default"].createElement(_uxcore.Spinner, null));
      }

      if (!loading && isBasketEmpty && !placeholders) {
        return _react["default"].createElement("div", {
          className: this.namespace('hc-loading')
        }, _react["default"].createElement(_reactIntl.FormattedMessage, {
          id: "Shared:UtilityBar:HeaderCart:emptyCart"
        }));
      }

      return _react["default"].createElement(_react["default"].Fragment, null, _react["default"].createElement("div", {
        className: this.namespace('hc-summary')
      }, _react["default"].createElement("span", {
        className: this.namespace('ms3')
      }, _react["default"].createElement("strong", null, _react["default"].createElement(_reactIntl.FormattedMessage, {
        id: "Shared:UtilityBar:HeaderCart:yourItems"
      }))), _react["default"].createElement("div", null, _react["default"].createElement("span", {
        className: this.namespace('ms-1 text-muted')
      }, !hasGroups && _react["default"].createElement(_reactIntl.FormattedMessage, {
        id: "Shared:UtilityBar:HeaderCart:subTotalPrefix"
      })), "\xA0", _react["default"].createElement("span", null, _react["default"].createElement("strong", null, editing || placeholders > 0 || isBasketEmpty ? _react["default"].createElement(_uxcore.Spinner, {
        inline: true,
        size: "md"
      }) : !hasGroups && (0, _helpers.formatPrice)(market, currency, basket.pricing.subtotal))))), _react["default"].createElement("hr", {
        className: this.namespace(this.classNames('m-b-1 hc-divider', {
          'hc-divider-overflow-border': hasOverflow
        }))
      }), _react["default"].createElement("div", {
        className: this.namespace('hc-items')
      }, _react["default"].createElement(_Expander["default"], {
        onOverflow: this.handleOverflow
      }, Array(placeholders).fill(0).map(function (_, index) {
        return _react["default"].createElement(_Placeholder["default"], {
          key: index
        });
      }), reversedItems && reversedItems.map(function (item) {
        return _react["default"].createElement(_Item["default"], {
          currency: currency,
          market: market,
          language: language,
          key: item.itemId,
          item: item,
          onDelete: function onDelete() {
            return _this3.handleDelete(item);
          },
          onDurationChange: function onDurationChange(e) {
            return _this3.handleDurationChange(item, e.value);
          }
        });
      }))), _react["default"].createElement("hr", {
        className: this.namespace(this.classNames('m-b-1 hc-divider', {
          'hc-divider-overflow-border': hasOverflow
        }))
      }));
    }
  }]);

  return CartContent;
}(_namespaceComponent.NamespaceConsumer);

CartContent.propTypes = {
  currency: _propTypes["default"].string.isRequired,
  market: _propTypes["default"].string.isRequired,
  language: _propTypes["default"].object.isRequired,
  basket: _propTypes["default"].object,
  loading: _propTypes["default"].bool,
  onChange: _propTypes["default"].func,
  placeholders: _propTypes["default"].number
};
var _default = CartContent;
exports["default"] = _default;